export default __webpack_public_path__ + "static/media/medway-branco-verde.44d37a2c.svg";